import { Loader, Select } from '@mantine/core';
import { IconMessage2 } from '@tabler/icons-react';
import { ReactNode, useMemo } from 'react';

import { useGetProphetPages, extractPageName } from '@/features/prophet';
import { Departments, Platforms } from '@/types';

type Props = {
  value?: string;
  onSelect: (value: string) => any;
  required?: boolean;
  disabled?: string[];
  department: Departments;
  platform: Platforms;
  error?: ReactNode | string;
};

export const ProphetPagesSelect = ({
  value,
  onSelect,
  required,
  platform,
  department,
  error,
  disabled,
}: Props) => {
  const { data, isLoading } = useGetProphetPages({ platform, department });

  const options = useMemo(() => {
    return data?.pages.map((page) => {
      return {
        value: page._id,
        label: extractPageName(page),
        disabled: disabled?.includes(page._id),
      };
    });
  }, [data?.pages, disabled]);

  return (
    <Select
      required={required}
      value={value}
      comboboxProps={{
        withinPortal: true,
        transitionProps: { transition: 'pop', duration: 200, timingFunction: 'ease' },
      }}
      data={options}
      placeholder="Pick a page to clone"
      searchable
      rightSection={isLoading ? <Loader size="xs" /> : null}
      leftSection={<IconMessage2 size="1rem" />}
      onChange={(value) => value && onSelect(value)}
      error={error}
    />
  );
};
